import { dummyConsole, dummyProfits } from "../dummyData";
import {
  handleError,
  handleRequestError,
  hostUrl,
  jsonHeaders,
  message,
  request,
  withDummyFallback,
} from "./core";

export const listConsole = (id) => {
  if (!id) return;
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: hostUrl("/users/list/console"),
    headers: jsonHeaders(),
    data: JSON.stringify({ id }),
  };
  return request(config)
    .then((response) => withDummyFallback(response.data, dummyConsole))
    .catch((error) => handleRequestError(error, dummyConsole));
};

export const syncConsole = () => {
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: hostUrl("/users/list/console/sync"),
    headers: jsonHeaders(),
    data: JSON.stringify({ id: "id" }),
  };
  return request(config)
    .then((response) => {
      message.success("Console sync started");
      return response.data;
    })
    .catch((error) => {
      handleError(error);
      message.error(error?.response?.data?.message || "Server is Down");
    });
};

export const listProfits = () => {
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: hostUrl("/users/list/console/profit"),
    headers: jsonHeaders(),
    data: JSON.stringify({ id: "id" }),
  };
  return request(config)
    .then((response) => withDummyFallback(response.data, dummyProfits))
    .catch((error) => handleRequestError(error, dummyProfits));
};

export const createConsole = (payload) => {
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: hostUrl("/users/console/create"),
    headers: jsonHeaders(),
    data: JSON.stringify(payload),
  };
  return request(config).catch((error) => {
    message.error(error?.response?.data?.message || "Server is Down");
    handleError(error);
  });
};

export const updateExpiry = (payload) => {
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: hostUrl("/users/update/expiry"),
    headers: jsonHeaders(),
    data: JSON.stringify(payload),
  };
  return request(config)
    .then(() => {
      message.success("Expiry updated successfully");
    })
    .catch((error) => {
      message.error(error?.response?.data?.message || "Server is Down");
      handleError(error);
    });
};
